import React from 'react';
import { Button, Popover, Switch } from 'antd';
import styles from './infrastructureSettingsPopover.module.scss';

interface InfrastructureSettingsPopoverProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  workOrderSummaryVisible: boolean;
  onWorkOrderSummaryVisibleChange: (checked: boolean) => void;
  workOrderCalendarVisible: boolean;
  onWorkOrderCalendarVisibleChange: (checked: boolean) => void;
  onOk: () => void;
  children: React.ReactNode;
}

const InfrastructureSettingsPopover: React.FC<InfrastructureSettingsPopoverProps> = ({
  open,
  onOpenChange,
  workOrderSummaryVisible,
  onWorkOrderSummaryVisibleChange,
  workOrderCalendarVisible,
  onWorkOrderCalendarVisibleChange,
  onOk,
  children,
}) => {
  const content = (
    <div className={styles.content}>
      <h3 className={styles.title}>Infrastructure Manager</h3>

      <div className={styles.row}>
        <span className={styles.label}>Work Order Summary</span>
        <Switch checked={workOrderSummaryVisible} onChange={onWorkOrderSummaryVisibleChange} />
      </div>

      <div className={styles.row}>
        <span className={styles.label}>Work Order Calendar</span>
        <Switch checked={workOrderCalendarVisible} onChange={onWorkOrderCalendarVisibleChange} />
      </div>

      <Button className={styles.okButton} onClick={onOk}>
        OK
      </Button>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={open}
      onOpenChange={onOpenChange}
      placement="topLeft"
      overlayClassName={styles.popover}
      arrow={false}
    >
      {children}
    </Popover>
  );
};

export default InfrastructureSettingsPopover;
